import { render, staticRenderFns } from "./x-tag.vue?vue&type=template&id=01a6349e&scoped=true&"
import script from "./x-tag.vue?vue&type=script&lang=js&"
export * from "./x-tag.vue?vue&type=script&lang=js&"
import style0 from "./x-tag.vue?vue&type=style&index=0&id=01a6349e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6349e",
  null
  
)

export default component.exports